export const getEnvironment = (hostname: string): "(O)" | "(T)" | "(A)" | "" => {
  if (hostname.toLowerCase().match(/^localhost/)) return "(O)";
  if (hostname.toLowerCase().match(/^test/)) return "(T)";
  if (hostname.toLowerCase().match(/^acc/)) return "(A)";
  return "";
};
